// extracted by css-extract-rspack-plugin
var _1 = "IJlOr2DGfSM_74Il";
var _2 = "oNvAb3yAA28r2RgL";
var _3 = "l2E0m83oD5m3RmNY";
var _4 = "OMRn1Fs9HXolRMVI";
var _5 = "uMDJ3ASpEY0teAN1";
var _6 = "BHVnKavNVQfirrh1";
var _7 = "R_dfVisxmfA2CQG0";
var _8 = "R_dfVisxmfA2CQG0";
var _9 = "jkEzOzm20QILXGjs";
var _a = "rx9wG1772RkWitMv";
var _b = "TJOpJraBPBsuTneW";
var _c = "XGO9OgG6fesZSQGe";
var _d = "f_rg4j5L73opsNpy";
var _e = "lNXZRYs0CtUGPE7S";
var _f = "rx9wG1772RkWitMv";
var _10 = "f_rg4j5L73opsNpy";
var _11 = "TJOpJraBPBsuTneW";
var _12 = "XGO9OgG6fesZSQGe";
var _13 = "lNXZRYs0CtUGPE7S";
var _14 = "SDjhbLNVfCQIEPMl";
var _15 = "qzL6QdFKpgYKMrAo";
export { _1 as "container", _2 as "header", _3 as "identifier", _4 as "photo", _5 as "sponsor", _6 as "stats", _7 as "statsItem", _8 as "stats__item", _9 as "title", _a as "top-part", _b as "top-part--no-media", _c as "top-part--no-stats", _d as "top-part__content", _e as "top-part__spacer", _f as "topPart", _10 as "topPartContent", _11 as "topPartNoMedia", _12 as "topPartNoStats", _13 as "topPartSpacer", _14 as "video", _15 as "wrapper" }
